import { getTranslationByPartnerAccess } from '../../../../helpers/getTranslationByPartnerAccess'
import { ITranslationOptions } from '../../../../models/translationOptions'
import { TRANSLATION_KEYS } from '../translations'

export const getPpsShareInputLabelTranslation = ({
  isRetail,
  isDistributor,
}: ITranslationOptions) => {
  return getTranslationByPartnerAccess(TRANSLATION_KEYS.ppsShareInput, {
    isRetail,
    isDistributor,
  })
}
